<template>
  <div id="pageRomaneios">
    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <div v-if="!paginatationDisabled">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="searchUser(1)">
              <v-row dense>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.id"
                    label="Id"
                  ></v-text-field>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.name"
                    label="Nome"
                  ></v-text-field>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.email"
                    label="E-mail"
                  ></v-text-field>
                </v-col>
                <v-col md="2" cols="12">
                  <v-text-field
                    v-model="searchData.document_number"
                    label="CPF"
                  ></v-text-field>
                </v-col>
                <v-col md="1" cols="12">
                  <v-select
                    v-model="searchData.hasProperty"
                    :items="hasPropertyItems"
                    label="Tem propriedade"
                    item-value="value"
                    item-text="text"
                  ></v-select>
                </v-col>

                <v-col align-self="center" md="3" cols="12">
                  <v-btn
                    @click="searchUser(1)"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon class="body-1">fa-search</v-icon>Buscar
                  </v-btn>
                  <v-btn
                    :to="{ name: 'UserIndex' }"
                    small
                    class="ma-1"
                    color="gray"
                    >Limpar</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-col cols="12">
          <v-row>
            <v-spacer></v-spacer>

            <v-btn
              :loading="loadingCsv"
              :disabled="loadingCsv"
              @click="genCsv()"
              small
              class="ma-1"
              color="primary"
            >
              Exportar
            </v-btn>
          </v-row>
        </v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              v-if="users.data"
              :headers="headers"
              :items="users.data"
              :mobile-breakpoint="960"
              disable-pagination
              hide-default-footer
              disable-sort
              class="animals-table"
            >
              <template v-slot:item.phone="{ item }">{{
                item.phone | formatPhone
              }}</template>

              <template v-slot:item.cpf="{ item }">{{
                item.cpf | formatCpf
              }}</template>

              <template v-slot:item.created_at="{ item }">{{
                item.created_at | formatDateHour
              }}</template>

              <template v-slot:item.properties_count="{ item }">
                <v-btn
                  text
                  :to="{
                    name: 'PropertyIndex',
                    query: { user: item.name }
                  }"
                  small
                >
                  <span class="indigo--text">
                    {{ item.properties_count }}
                  </span>
                </v-btn>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-row align-content="center">
                  <v-btn
                    :to="{ name: 'User', params: { id: item.id } }"
                    small
                    icon
                    color="primary"
                  >
                    <v-icon>fa-edit</v-icon>
                  </v-btn>
                  <v-btn
                    class="ml-1"
                    @click="deleteUserRequest(item)"
                    small
                    icon
                    color="error"
                  >
                    <v-icon>fas fa-trash-alt</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="!item.push_notification"
                    class="ml-1"
                    @click="showNotificationDialog(item)"
                    small
                    icon
                    color="primary"
                  >
                    <v-icon>fas fa-comment-dots</v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <app-pagination
          v-if="users && users.pagination"
          :pagination="users.pagination"
          :disabled="paginatationDisabled"
          v-on:change-page="searchUser"
        ></app-pagination>
      </div>

      <app-confirm-modal></app-confirm-modal>

      <v-layout row justify-center>
        <v-dialog persistent v-model="deleteUserDialog" max-width="600px">
          <v-card>
            <v-card-title class="error white--text" primary-title>
              <span class="headline">Atenção!</span>
            </v-card-title>
            <v-card-text
              ><v-row class="py-3">
                Para excluir o usuário
                <b class="mx-1">{{ userToDelete.name }}</b> digite sua senha
                abaixo
              </v-row>

              <v-row justify="center">
                <v-col cols="6">
                  <v-text-field
                    v-model="password"
                    name="password"
                    :error="form.deleteUser.password.error"
                    :error-messages="form.deleteUser.password.message"
                    @keyup="
                      form.deleteUser.password.error = false;
                      form.deleteUser.password.message = '';
                    "
                    label="Senha"
                    type="password"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="deleteUser">
                Confirmar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="deleteUserDialog = false"
                >Cancelar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-dialog v-model="notificationDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <v-row justify="space-between" no-gutters>
              <span class="headline cardtitle"
                >Envio de Notificação para
                {{ notification.user && notification.user.name }}
              </span>
              <v-btn
                @click="notificationDialog = false"
                small
                icon
                color="error"
              >
                <v-icon>fas fa-times-circle</v-icon>
              </v-btn>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters justify="center">
              <v-col cols="8">
                <v-text-field
                  class="mt-3"
                  v-model="notification.title"
                  :error="form.notification.title.error"
                  :error-messages="form.notification.title.message"
                  @keyup="clearMessage('title')"
                  label="Título"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center">
              <v-col cols="8">
                <v-textarea
                  v-model="notification.content"
                  :error="form.notification.content.error"
                  :error-messages="form.notification.content.message"
                  @keyup="clearMessage('content')"
                  label="Conteúdo"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center">
              <v-col cols="8">
                <v-btn
                  block
                  @click="sendUserNotification"
                  color="blue"
                  class="white--text"
                >
                  ENVIAR
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import AppPagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      notification: {},
      form: {
        deleteUser: {
          password: {
            error: false,
            message: ""
          }
        },
        notification: {
          title: {
            error: false,
            message: ""
          },
          content: {
            error: false,
            message: ""
          }
        }
      },
      modalType: null,
      headers: [
        { text: "Id", value: "id", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "E-mail", value: "email", sortable: false },
        { text: "Celular", value: "phone", sortable: false },
        { text: "CPF", value: "cpf", sortable: false },
        { text: "Data cadastro", value: "created_at", sortable: false },
        { text: "Propriedades", value: "properties_count", sortable: false },
        { text: "Ações", value: "actions", sortable: false }
      ],
      hasPropertyItems: [
        { text: "Todos", value: 0 },
        { text: "Sim", value: 1 },
        { text: "Não", value: 2 }
      ],
      users: {},
      currentPage: 1,
      password: null,
      paginatationDisabled: false,
      dialog: false,
      notificationDialog: false,
      snackbarCsv: false,
      updateIdx: null,
      deleteMessage: "",
      loadingCsv: false,
      snackbar: {},
      searchData: {},
      userToDelete: {},
      deleteUserDialog: false,
      formatDates: {
        intlDate: "YYYY-MM-DD",
        ini: {
          date: "",
          modalDateInit: false
        },
        end: {
          date: "",
          modalDateInit: false
        }
      }
    };
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0);

    if (this.$route.query.page) {
      this.searchData["page"] = this.$route.query.page;
    } else {
      this.searchData["page"] = 1;
    }

    if (this.$route.query.id) {
      this.searchData["id"] = this.$route.query.id;
    }
    if (this.$route.query.name) {
      this.searchData["name"] = this.$route.query.name;
    }
    if (this.$route.query.document_number) {
      this.searchData["document_number"] = this.$route.query.document_number;
    }
    if (this.$route.query.email) {
      this.searchData["email"] = this.$route.query.email;
    }
    if (this.$route.query.hasProperty) {
      this.searchData["hasProperty"] = this.$route.query.hasProperty;
    } else {
      this.searchData["hasProperty"] = 0;
    }

    this.getUser(this.searchData);
  },

  methods: {
    deleteUserRequest(user) {
      this.deleteUserDialog = true;
      this.password = "";
      this.form.deleteUser.error = false;
      this.form.deleteUser.message = "";
      this.userToDelete = user;
    },
    async genCsv() {
      this.loadingCsv = true;
      const { Parser } = require("json2csv");

      let page = 1;
      const { lastPage } = this.users.pagination;

      let dataResult = [];

      while (page <= lastPage) {
        const res = await appApi.getUsers({ ...this.searchData, page });

        let filteredUsers = res.data.data.map(user => {
          const { name, email, phone, cpf, created_at } = user;
          return {
            Nome: this.removerAcentos(name),
            Email: email,
            Telefone: phone,
            CPF: cpf,
            DataCadastro: moment(created_at).format("DD/MM/YYYY")
          };
        });

        dataResult.push(...filteredUsers);
        page++;
      }

      const json2csvParser = new Parser();
      const csv = json2csvParser.parse(dataResult);

      this.download(csv, "users_export.csv");
      this.loadingCsv = false;
    },

    removerAcentos(text) {
      // text = text.toLowerCase();
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      return text;
    },

    download(data, fileName = "download", type = "text/csv") {
      const content = URL.createObjectURL(new Blob([data], { type: type }));

      if (localStorage.getItem("is_mobile") === "true") {
        window.open(
          content,
          "_blank",
          "location=no,closebuttoncaption=Cerrar,toolbar=yes,enableViewportScale=yes"
        );
      } else {
        const link = document.createElement("a");
        link.setAttribute("href", content);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", fileName);
        document.body.appendChild(link); // Required for FF
        link.click();
      }
    },

    clearMessage(field) {
      this.form.notification[field].error = false;
      this.form.notification[field].message = "";
    },
    showNotificationDialog(user) {
      this.notification = {};
      this.notification["user"] = user;
      this.notificationDialog = true;
    },
    sendUserNotification() {
      appApi
        .postUserPushNotification({
          user_id: this.notification.user.id,
          content: this.notification.content,
          title: this.notification.title
        })
        .then(res => {
          this.snackbar = {
            show: true,
            color: "success",
            text: "Notificação enviada com sucesso"
          };

          this.notificationDialog = false;
        })
        .catch(err => {
          if (err.response && err.response.data) {
            for (const e of err.response.data) {
              this.form.notification[e.field].error = true;
              this.form.notification[e.field].message = e.message;
            }
          }
        });
    },
    searchUser: function(page) {
      let data = { page: page ? page : 1 };

      if (this.searchData.id) {
        data["id"] = this.searchData.id;
      }
      if (this.searchData.document_number) {
        data["document_number"] = this.searchData.document_number.replace(
          /\D/g,
          ""
        );
      }
      if (this.searchData.name) {
        data["name"] = this.searchData.name;
      }
      if (this.searchData.email) {
        data["email"] = this.searchData.email;
      }
      if (this.searchData.hasProperty) {
        data["hasProperty"] = this.searchData.hasProperty;
      }
      this.$router.push({ name: "UserIndex", query: data });
    },

    getUser: function(data) {
      this.paginatationDisabled = true;
      this.users.data = [];
      appApi
        .getUsers(data)
        .then(result => {
          this.users = result.data;
          this.paginatationDisabled = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    deleteUser(answer) {
      appApi
        .deleteUser(this.userToDelete.id, { password: this.password })
        .then(() => {
          this.snackbar = {
            show: true,
            color: "success",
            text: "Usuário deletado com sucesso"
          };

          const userIdxToDel = this.users.data.findIndex(item => {
            return item.id === this.userToDelete.id;
          });

          this.users.data.splice(userIdxToDel, 1);
          this.deleteUserDialog = false;
        })
        .catch(err => {
          if (err.response && err.response.data) {
            for (const e of err.response.data) {
              this.form.deleteUser[e.field].error = true;
              this.form.deleteUser[e.field].message = e.message;
            }
          }
        });
    }
  }
};
</script>
<style scoped lang="css">
>>> .v-data-table-header.v-data-table-header-mobile {
  display: none;


}


.cardtitle{
max-width: 90%;
}
</style>
